'use strict';

import util from './util';

// function to enable floating label of input fields
function floatingInputfieldLabel() {
    var $inputfield = $('.enabled-floating-label .input-text');
    $inputfield.closest('.form-row').addClass('floating-label');
    
    $(window).on('load', function() {
        $inputfield.each(function() {
            if($(this).val() !== '') {
                $(this).closest('.floating-label').addClass('should-float');
            }
        })
    });    
    $inputfield.on('focusin', function(){
        $(this).closest('.floating-label').addClass('should-float');
    });
    $inputfield.on('focusout', function(){
        if($(this).val() === '') {
            $(this).closest('.floating-label').removeClass('should-float');
        }
        // remove birthday field error when form is invalid
        if($(this).closest('form').find('.birthday-fields span.error').css('display') == 'none') {
            $(this).closest('form').find('.birthday-fields span.error').remove();
        }    
    });
}

// function to bind DOM events
function newsletterDOMEvents() {
    $('.optional-field input.phonenumber').each(function (index, ele) {$(ele).removeClass('required'); });
    // Footer Newsletter - Step 1
    $(document).on('submit', '.newsletter-content-zone-right .newsletter-form-container .newsletter-form-step1', function (e) {
        e.preventDefault();        
        if($(this).closest('form').valid() && validateBirthDateOnFormSubmit($(this).closest('form'))) {
            // to disable submit button
            $(this).find('button[type="submit"]').prop('disabled', true);  
            var emailAddress = $(this).find('#dwfrm_newsletter_email').val();
            var source = $(this).closest('.newsletter-form').find('input[name="source"]').val(); 
            var parentdiv = $(this).closest('.footer-newsletter-section').length ? '.footer-newsletter-section .newsletter-module' : '.campaign-section .newsletter-module'; 
            validateNewsletter(false, emailAddress, source, parentdiv);
        }
    });
    
    // Footer Newsletter - Step 2 - Skip button
    $(document).on('click', '.newsletter-module .footer-skip-btn', function (e) {
        e.preventDefault();
        var parentdiv = $(this).closest('.footer-newsletter-section').length ? '.footer-newsletter-section .newsletter-module' : '.campaign-section .newsletter-module';
        var source = $(this).closest('.step-2 .newsletter-content-zone-right').find('input[name="source"]').val(); 
        
        $.ajax({
            type: 'GET',
            url: util.appendParamsToUrl(Urls.newsletterSuccessMsg, {source : source}),
            success: function(response) {
            	$(parentdiv).html(response);
                $(window).width() < 991 && $('html, body').animate({scrollTop: $(parentdiv).offset().top - 100}, 1000);
            }
        });
    });
    
    // Footer Newsletter - Step 2 - Submit button
    $(document).on('submit', '.newsletter-content-zone-right .newsletter-form-container .newsletter-form-step2', function (e) {
        e.preventDefault();
        var parentdiv = $(this).closest('.footer-newsletter-section').length ? '.footer-newsletter-section .newsletter-module' : '.campaign-section .newsletter-module';
        var source = $(this).closest('.step-2 .newsletter-content-zone-right').find('input[name="source"]').val();  
        var intrestsArray = [];
        $(parentdiv).find('.checklist input[type=checkbox]').each(function () {
     	   if(this.checked) {
     		   intrestsArray.push($(this).val());
     	   }
     	});

        if(intrestsArray.length) {
            var postData = {};
            postData.intrestsArr = intrestsArray.join().toString();
            postData.source = source;
            $.ajax({
                type: 'POST',
                url: Urls.optInMyIntrests,
                data: postData,
                success: function(response) {
                    $(parentdiv).html(response);
                }
            });
            $('.newsletter-content-zone-right #newsletter-interests-error').addClass('hide');
            $(this).find('button[type="submit"]').prop('disabled', true);
        } else {
            $('.newsletter-content-zone-right #newsletter-interests-error').removeClass('hide');
            $(this).find('button[type="submit"]').prop('disabled', false);   
            return false;
        } 
        $(window).width() < 991 && $('html, body').animate({scrollTop: $(parentdiv).offset().top - 100}, 1000);   
    });

    // to hide error message when atleast 1 checkbox selected
    $(document).on('change', '.newsletter-content-zone-right .checklist input[type=checkbox]', function (e) {
        if(this.checked) {
            $('.newsletter-content-zone-right #newsletter-interests-error').addClass('hide');
        }
    });
}

// function to display see more and see less text in user-consent
function toggleContent() {
    var $selector = $('.toggle-content-wrapper');
    $selector.on('click', '.btn-see-more', function(){
        $(this).closest('.toggle-content-wrapper').removeClass('see-more').addClass('see-less');
    });
    $selector.on('click', '.btn-see-less', function(){
        $(this).closest('.toggle-content-wrapper').removeClass('see-less').addClass('see-more');
    });   
}

function validateNewsletter(isModal, emailAddress, source, parentdiv) {
    var validateClass = '';
    validateClass = parentdiv+' .newsletter-form';

    if (isModal) {
        validateClass = '.modal-content';
    }

    $(validateClass + ' input').removeAttr('aria-invalid');
    $(validateClass + ' input').removeAttr('aria-describedby');
    $(validateClass + ' input').removeAttr('class');
        
    var postData = ['dwfrm_newsletter_email=', emailAddress].join('');
    var dataObj = {
        email: emailAddress,
        source: isModal ? 'modal' : source
    };
    var formAction = $(parentdiv).find('.newsletter-form-container form').attr('action');

    //add fname and lname if newsletter fro footer has been clicked
    postData += $(parentdiv).find('#dwfrm_newsletter_firstName') != undefined ? $(parentdiv).find('#dwfrm_newsletter_firstName').val() : '';
    postData += $(parentdiv).find('#dwfrm_newsletter_lastName') != undefined ? $(parentdiv).find('#dwfrm_newsletter_lastName').val() : '';
    postData += $(parentdiv).find('#dwfrm_newsletter_customer_birthmonth') != undefined ? $(parentdiv).find('#dwfrm_newsletter_customer_birthmonth').val() : '';
    postData += $(parentdiv).find('#dwfrm_newsletter_customer_dob') != undefined ? $(parentdiv).find('#dwfrm_newsletter_customer_dob').val() : '';
    postData += $(parentdiv).find('#dwfrm_newsletter_customer_birthyear') != undefined ? $(parentdiv).find('#dwfrm_newsletter_customer_birthyear').val() : '';
    postData += $(parentdiv).find('#dwfrm_newsletter_openQuestion') != undefined ? $(parentdiv).find('#dwfrm_newsletter_openQuestion').val() : '';
    dataObj.firstName = $(parentdiv).find('#dwfrm_newsletter_firstName') != undefined ? $(parentdiv).find('#dwfrm_newsletter_firstName').val() : '';
    dataObj.lastName = $(parentdiv).find('#dwfrm_newsletter_lastName') != undefined ? $(parentdiv).find('#dwfrm_newsletter_lastName').val() : '';
    dataObj.birthday = $(parentdiv).find('#dwfrm_newsletter_customer_dob') != undefined ? $(parentdiv).find('#dwfrm_newsletter_customer_dob').val() : '';
    dataObj.birthmonth = $(parentdiv).find('#dwfrm_newsletter_customer_birthmonth') != undefined ? $(parentdiv).find('#dwfrm_newsletter_customer_birthmonth').val() : '';
    dataObj.birthyear = $(parentdiv).find('#dwfrm_newsletter_customer_birthyear') != undefined ? $(parentdiv).find('#dwfrm_newsletter_customer_birthyear').val() : '';
    dataObj.shiInterests = $(parentdiv).find('#sh-interest-check').length > 0 ? true : false;
    dataObj.shiTermsConditions = $(parentdiv).find('#terms-condition-check').length > 0 ? true : false;
    dataObj.openQuestion = $(parentdiv).find('#dwfrm_newsletter_openQuestion') != undefined ? $(parentdiv).find('#dwfrm_newsletter_openQuestion').val() : '';
    var selectedCountryCode = $('input[name$="_country"]').val();
    var areaCode = util.getCallingCountryCode(selectedCountryCode.toLowerCase());
    if (selectedCountryCode) {
        if (areaCode == $(parentdiv).find('#dwfrm_newsletter_phone').val() || $(parentdiv).find('#dwfrm_newsletter_phone') == undefined) {
            dataObj.phone = '';
        } else {
            dataObj.phone = $(parentdiv).find('#dwfrm_newsletter_phone').val();
        }
    }
    var servicesOpted = [];
    $(parentdiv).find('.profile-optin-checkboxes input[type=checkbox]').each(function () {
 	   if(this.checked) {
 		  servicesOpted.push($(this).val());
 	   }
 	});
    dataObj.servicesOpted = servicesOpted.join().toString();
    
    $.ajax({
        type: 'POST',
        url: formAction,
        data: dataObj,
        success: function (response) {
            if (isModal) {
                modal.renderContent(response);
                modal.addCustomClass('newsletter-signup-modal');
                $(document).trigger('clicknewsletter',{'siteloc':'pop-up'});
                if($('input[id="promo-code"]').val() == '') {
                    $('.promo-wrapper').hide();
                } else {
                    $('.promo-wrapper').show();
                }
            } else {
                $(parentdiv).html(response);
                var offSet = $(parentdiv).closest('.footer-newsletter-section').length ?  100 : $(window).height()/2;   
                $(window).width() < 991 && $('html, body').animate({scrollTop: $(parentdiv).offset().top - offSet}, 1000);
                $(document).trigger('clicknewsletter',{'siteloc':'footer'});
            }
        }
    });
}

// function to validate phone field on SMS option checked
function validatePhoneField() {
    var $selector = $('.newsletter-module');
    $selector.on('change', '#sms-check', function(e) {
        if (this.checked) {
        	$(this).closest('.newsletter-module').find('input[id$="_newsletter_phone"]').attr('required', 'true');
        } else {
        	$(this).closest('.newsletter-module').find('input[id$="_newsletter_phone"]').removeAttr('required');   
        }
    });
}

function validateBirthdayFields(current) {
    var $birthdayFields = $(current).closest('.birthday-fields'),
        $month = $birthdayFields.find('.input-select.birthmonth'),
        $day = $birthdayFields.find('.input-select.dob'),
        $year = $birthdayFields.find('.input-text.birthyear'),
        $dobError = $birthdayFields.find('div.dob span.error'),        
        yearRegex = /(?:(?:19|20|21)[0-9]{2})$/,
        leapYear = new Date($year.val(), 1, 29).getDate() === 29;
    
    // check one of the field having invalid entry
    if ($month.val() === '00' || $day.val() === '00' || !yearRegex.test($year.val())) {
        $dobError.length === 0 && $('<span class="error">'+ Resources.INVALID_DATE +'</span>').insertBefore($day);
    }
    // check if year is a leap year
    else if ($month.val() == '02' && !leapYear && $day.val() > 28) {
        $dobError.length === 0 && $('<span class="error">'+ Resources.INVALID_DATE +'</span>').insertBefore($day);
    }
    // check if year is not a leap year
    else if ($month.val() == '02' && leapYear && $day.val() > 29) {
        $dobError.length === 0 && $('<span class="error">'+ Resources.INVALID_DATE +'</span>').insertBefore($day);
    }
    // Check if month has 30 days
    else if (($month.val() === '04' || $month.val() === '06' || $month.val() === '09' || $month.val() === '11') && $day.val() > 30) {
        $dobError.length === 0 && $('<span class="error">'+ Resources.INVALID_DATE +'</span>').insertBefore($day);
    }
    // to check user is less tha 16 yrs of age
    else if (!validate16YrsOfAge($day.val(), $month.val(), $year.val())) {
        if($dobError.length > 0) {
            $birthdayFields.find('div.dob span.error').remove();
            $('<span class="error">'+ Resources.INVALID_BIRTHDAY +'</span>').insertBefore($day);
        } else if($dobError.length === 0) {
            $('<span class="error">'+ Resources.INVALID_BIRTHDAY +'</span>').insertBefore($day);
        }
    } else {
        $birthdayFields.find('div.dob span.error').remove();
    }

    // to remove error when all feilds reset
    if ($month.val() === '00' && $day.val() === '00' && $year.val() === '') {
        $dobError.length && $birthdayFields.find('div.dob span.error').remove();       
    }
}

// Validate Date of Birth on form submit
function validateBirthDateOnFormSubmit(form) {
    var $month = $(form).find('.birthday-fields .input-select.birthmonth'),
        $day = $(form).find('.birthday-fields .input-select.dob'),
        $year = $(form).find('.birthday-fields .input-text.birthyear'),
        $dobError = $(form).find('.birthday-fields div.dob span.error'),
        yearRegex = /(?:(?:19|20|21)[0-9]{2})$/,
        leapYear = new Date($year.val(), 1, 29).getDate() === 29,
        isValidAge = validate16YrsOfAge($day.val(), $month.val(), $year.val());
    
    if ($day.val() === '00' && $month.val() === '00' && $year.val() == '') {
        return true;
    } else if ($month.val() === '02' && !leapYear && $day.val() !== '00' && $day.val() <= 28 && yearRegex.test($year.val()) && isValidAge) {
        return true;
    } else if ($month.val() === '02' && leapYear && $day.val() !== '00' && $day.val() <= 29 && yearRegex.test($year.val()) && isValidAge) {
        return true;
    } else if (($month.val() === '04' || $month.val() === '06' || $month.val() === '09' || $month.val() === '11') && $month.val() !== '00' && $day.val() !== '00' && $day.val() <= 30 && yearRegex.test($year.val()) && isValidAge) {        
        return true;
    } else if (($month.val() !== '02' && $month.val() !== '04' && $month.val() !== '06' && $month.val() !== '09' && $month.val() !== '11') && $month.val() !== '00' && $day.val() !== '00' && yearRegex.test($year.val()) && isValidAge) {        
        return true;
    } else {
        if($dobError.length > 0 || $dobError.css('display') == 'none') {
            $dobError.remove();
            $('<span class="error">'+ Resources.INVALID_DATE +'</span>').insertBefore($day);
            return false;
        }
    }
}

function updateNewsLetterBirthday() {
    $('.birthday-fields .input-text.birthyear').on('change', function(event){
        validateBirthdayFields(event.target);
    }); 
}

function validate16YrsOfAge(day, month, year) {
    var dd = parseInt(day),
        mm = parseInt(month),
        yy = parseInt(year);    
    return new Date(yy+16, mm-1, dd) <= new Date();
}

var expandNewsletter = function() {
    $(document).on('click', '.footer-newsletter-section .newsletter-form-container .email', function(e) {
        $(document).find('.footer-newsletter-section .newsletter-expand-section').removeClass('hide'); 
        $(document).find('.footer-newsletter-section .email-field').removeClass('email-without-focus'); 
    });
}

var newsletterModule = {	
    init: function () {
        floatingInputfieldLabel();
        newsletterDOMEvents();
        toggleContent();
        validatePhoneField();
        updateNewsLetterBirthday();
        util.footerNewsletterWithCode();
        expandNewsletter();
    }
};

export default newsletterModule;
